import { render, staticRenderFns } from "./DiscussionChangeCloseState.vue?vue&type=template&id=425ceb96&"
import script from "./DiscussionChangeCloseState.vue?vue&type=script&lang=js&"
export * from "./DiscussionChangeCloseState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports